import fetchWrapper from "@/api/fetch-wrapper";
import { CALCULATOR_TYPE } from "@/consts";

export const validateCoupon = (coupon) => {
    const body = {
        type: CALCULATOR_TYPE,
        action: 'getCoupon',
        coupon
    }

    const query = `/.ajax/order.php`;
    
    return fetchWrapper.post(query, body);
}
